(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // gallery thumbnails
  var main = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      var src = btn.getAttribute('data-src');
      var alt = btn.getAttribute('data-alt') || '';
      main.src = src;
      main.alt = alt;
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // variant radio -> update price + hidden id
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var priceEl = document.querySelector('[data-price]');
    var idInput = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[data-submit]');
    form.querySelectorAll('input[name="id"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (idInput) idInput.value = radio.value;
        var price = radio.getAttribute('data-price');
        var avail = radio.getAttribute('data-available') === 'true';
        if (priceEl && price) priceEl.textContent = price;
        if (submit) {
          submit.disabled = !avail;
          submit.textContent = avail ? submit.getAttribute('data-label') : submit.getAttribute('data-soldout');
        }
        var img = radio.getAttribute('data-image');
        if (img && main) { main.src = img; }
        var opt = form.querySelector('[data-selected-colour]');
        if (opt) opt.textContent = radio.getAttribute('data-name');
      });
    });
  }
})();
